module.exports = __webpack_public_path__ + "static/media/hg.9c5c497b.jpeg";